import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentsActions } from '../_store/document.slice';
import PdfViewer from '../components/common/PdfViewer';
import Table from '../components/common/CustomTable';
import Button from '../components/common/ui/Button';
import CustomModal from '../components/common/CustomModal ';
import Loader from '../components/common/Loader';
import TranslateFile from '../Loc/TranslateFile';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../src/_helpers/storageHelper";

const Documents = () => {
    const { loginResponse } = useSelector(state => state.kioskLogin);
    const { LoadDocumentSearchDetails, DownloadFileFromPathResponses } = useSelector(state => state.Documents);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails");
    const dispatch = useDispatch();
    const [isshowListPage, setisshowListPage] = React.useState(true);
    const [isLoading, setLoading] = useState(false);
    const [showPopup, setshowPopup] = React.useState(false);
    const currentLang = TranslateFile();
    const isPageReloading = useSelector((state) => state.auth?.isPageReload);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    const columns = [
        {
            name: currentLang?.TableHeaders?.Document_Title, selector: (row) => row.DocumentTitle, sortable: true,
            cell: (row) => (
                (
                    <div className="d-flex align-items-center" onClick={() => { handleONCLick(row) }}>
                        <span> <i className="fa-solid fa-file-text icon color-gray"></i></span>
                        <div className="request-text" dangerouslySetInnerHTML={{ __html: row?.DocumentTitle }} />
                    </div>
                )
            ),
            sortFunction: (a, b) => a.DocumentTitle.toLowerCase().localeCompare(b.DocumentTitle.toLowerCase())
        },
    ];

    const fetchDocuments = () => {
        setLoading(LoadDocumentSearchDetails?.length > 0 ? false : true);
        var Objectdata = {
            activeStatus: 1, sortBy: "DocumentID DESC", documentTitle: '', documentUploadStartDate: '', documentUploadEndDate: '',
            facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        };
        dispatch(DocumentsActions.getLoadDocumentSearch(Objectdata)).then(x => {
            setLoading(false);
        });
    };

    useEffect(() => {
        setisshowListPage(true)
        fetchDocuments();
    }, [isPageReloading]);


    const getfolderPath = (fileSavedPath) => {
        const lastIndex = fileSavedPath.lastIndexOf("/") + 1; // Get the index of the last '/'
        return fileSavedPath.substring(0, lastIndex).trimEnd(); // Get the substring and trim any trailing spaces
    };

    const handleONCLick = (item) => {
        setLoading(true);
        const Objectdata = {
            activeStatus: 1,
            sortBy: '',
            documentTitle: '',
            documentUploadStartDate: '',
            documentUploadEndDate: '',
            facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        };
        dispatch(DocumentsActions.getLoadDocumentSearch(Objectdata))
            .then((x) => {
                const result = x?.payload;
                setLoading(false);
                const selectdoc = result?.find(x => x?.DocumentID === item?.DocumentID);
                if (selectdoc?.ActiveStatus === "Active" && selectdoc?.DocumentID) {

                    let folderPath = getfolderPath(selectdoc?.DocumentPath);
                    if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
                        folderPath = `${process.env.REACT_APP_FOLDER_PATH}${getfolderPath(selectdoc?.DocumentPath)}`;
                    }

                    const filename = selectdoc?.DocumentFileName;
                    dispatch(DocumentsActions.getDownloadFileFromPath({ folderPath, filename }))
                        .then(x => {
                            if (x?.payload) {
                                setisshowListPage(false); setLoading(false);
                            }
                            else {
                                setisshowListPage(true); setshowPopup(true); setLoading(false);
                            }
                        })
                    setisshowListPage(false);
                } else {
                    setshowPopup(true);
                }
                // fetchDocuments();
            })
            .catch((error) => {
                setLoading(false);
                setshowPopup(true);

            });
    };

    const showListPage = () => {
        setisshowListPage(true);
        fetchDocuments();
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="d-flex justify-content-between mb-1 pt-1">
                    <div className="align-self-start">
                        <div className="icon-container">
                            <h3 className="find-inmate-head">{currentLang?.Documents}</h3>
                        </div>
                    </div>
                    {!isshowListPage && <div className="align-self-end">
                        <Button className='btn-danger ' label={currentLang?.Buttons?.Back} type="button" status="back" onClick={() => { showListPage() }} />
                    </div>}
                </div>
                <div className="divider mb-3"></div>

                <div className="card-default">
                    {isshowListPage ?
                        (LoadDocumentSearchDetails?.length > 0 ?
                            <Table
                                isScrollContainer={true}
                                columns={columns}
                                data={LoadDocumentSearchDetails}
                                pagination={false}
                                handleONCLick={handleONCLick}
                                //onChangeRowsPerPage={handleonChangeRowsPerPage}
                                // onChangePage={handlePageChange}
                                totalRowCount={LoadDocumentSearchDetails?.length}
                                // currentPage={currentPage}
                                //paginationPerPage={rowPerPage}
                                paginationServer={true}
                            />
                            : <span className="col-no-data">{currentLang?.No_Data_Found}</span>) : <PdfViewer base64={DownloadFileFromPathResponses} />
                    }
                </div>
                {showPopup && (
                    <CustomModal color='#c8605e' content={currentLang?.AlertPopup?.File_not_exist_in_uploaded_directory} onOkClick={() => { setshowPopup(false); }} />
                )}
                {isLoading && <Loader />}
            </div>
        </div>
    );
};

export default memo(Documents);
